import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import paymentActions from "../../store/actions/payment";
import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import InputMask from 'react-input-mask';

const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const allYears = [];

  for (let i = 0; i < 10; i++) {
    const value = (currentYear + i).toString();

      allYears.push({ value, label: value });
  };

  return allYears;
};

const PaymentSteps = () => {
  const paymentStore = useSelector((store) => store.paymentStore);
  const dispatch = useDispatch();
  const [situation, setSituation] = useState(null);
  const [formValid, setFormValid] = useState(null);
  const [tipOpen, setTipOpen] = useState(false);
  const [tipBankAccountOpen, setTipBankAccountOpen] = useState(false);
  const [cardMask, setCardMask] = useState('9999 9999 9999 9999');
  const [cardType, setCardType] = useState(null);
  const reg_ex = /^[0-9]*\.?[0-9]*$/;
  const user = paymentStore.user;

  const customStyles = {
    valueContainer: (provided, state) => ({
      ...provided,
      padding: 0,
    }),
    input: (provided) => ({
      ...provided,
      padding: '0 0 3px 0',
      margin: 0,
    }),
    control: (provided) => ({
      ...provided,
      cursor: 'pointer',
      borderRadius: 0,
      border: 'none',
      paddinBottom: '4px',
      minHeight: 'unset',
      boxShadow: 'none',
    }),
  }

  const openTooltip = () => {
    setTipOpen(!tipOpen);
  }

  const openBankAccountTooltip = () => {
    setTipBankAccountOpen(!tipBankAccountOpen);
  }

  const checkSituation = () => {
    let situationValue = '';
    if (user.minimumDue === 0.00 && user.balance === 0.00){
      //no due no balance
      situationValue = 1;
      dispatch(paymentActions.setPaymentType('custom'));
    } else if (user.minimumDue === 0.00 && user.balance !== 0.00) {
      //no due has balance
      situationValue = 2;
    } else if (user.minimumDue !== 0.00 && user.balance !== 0.00) {
      if (user.pastDue) {
        //has past due has balance
        situationValue = 3;
      } else {
        //has due has balance
        situationValue = 4;
      }
    }
    else if (user.minimumDue !== 0.00 && user.balance === 0.00) {
      if (user.pastDue) {
        //has past due no balance
        situationValue = 5;
      } else {
        //has due no balance
        situationValue = 6;
      }
    }
    setSituation(situationValue);
  }

  const changePaymentType = (type) => {
    dispatch(paymentActions.setPaymentType(type));
    if (type === 'due') {
      dispatch(paymentActions.setPaymentAmount(user.minimumDue.toString()));
      dispatch(paymentActions.setStepSecondDone(true));
    } else if (type === 'total') {
      dispatch(paymentActions.setPaymentAmount(user.balance.toString()));
      if (user.balance !== 0.00) {
        dispatch(paymentActions.setStepSecondDone(true));
      } else {
        dispatch(paymentActions.setStepSecondDone(false));
      }
    } else if (type === 'custom') {
      applyAmount(paymentStore.paymentCustomAmount);
    }
  }

  const changeCustomAmount = (value) => {
    if (value === '' || value.match(reg_ex) && parseFloat(value) <= 99999.99 && value.length < 9){
      applyAmount(value);
    }
  }

  const floatCustomAmount = () => {
    let value = paymentStore.paymentCustomAmount;
    if (value.length > 0 && parseFloat(value) < 99999.99) {
      value = parseFloat(value).toFixed(2);
    }
    applyAmount(value);
  }

  const applyAmount = (val) => {
    dispatch(paymentActions.setPaymentCustomAmount(val));
    dispatch(paymentActions.setPaymentAmount(val));
    if (parseFloat(val) > 0.00 && parseFloat(val) <= 99999.99) {
      dispatch(paymentActions.setStepSecondDone(true));
    } else {
      dispatch(paymentActions.setStepSecondDone(false));
    }
  }

  const changeConfirmType = (type) => {
    dispatch(paymentActions.setConfirmType(type));
    if (type === 'none') {
      dispatch(paymentActions.setConfirmEmail(''));
      dispatch(paymentActions.setStepThirdDone(true));
    } else if (type === 'user') {
      dispatch(paymentActions.setConfirmEmail(user.email));
      dispatch(paymentActions.setStepThirdDone(true));
    } else if (type === 'custom') {
      if (validateEmail(paymentStore.confirmCustomEmail)) {
        dispatch(paymentActions.setConfirmEmail(paymentStore.confirmCustomEmail));
        dispatch(paymentActions.setStepThirdDone(true));
      } else {
        dispatch(paymentActions.setConfirmEmail(''));
        dispatch(paymentActions.setStepThirdDone(false));
      }
    }
  }

  const changeCustomEmail = (value) => {
    dispatch(paymentActions.setConfirmCustomEmail(value));

    if (paymentStore.confirmType === 'custom') {

      if (validateEmail(value)) {
        dispatch(paymentActions.setConfirmEmail(value));
        dispatch(paymentActions.setStepThirdDone(true));
      } else {
        dispatch(paymentActions.setConfirmEmail(''));
        dispatch(paymentActions.setStepThirdDone(false));
      }
    }
  }

  const changePaymentMethod = (value) => {
    dispatch(paymentActions.setPaymentMethod(value));
    dispatch(paymentActions.setStepFourthDone(true));
  }

  const creditCardType = (cc) => {
    let amex = new RegExp('^3[47]');
    let visa = new RegExp('^4[0-9]');
    let cup1 = new RegExp('^62[0-9]');
    let cup2 = new RegExp('^81[0-9]');

    let mastercard = new RegExp('^5[1-5]');
    let mastercard2 = new RegExp('^2[2-7]');

    let disco1 = new RegExp('^6011');
    let disco2 = new RegExp('^62[24568]');
    let disco3 = new RegExp('^6[45]');

    let diners = new RegExp('^3[0689]');
    let jcb =  new RegExp('^35[0-9]');


    if (visa.test(cc)) {
      setCardMask('9999 9999 9999 9999')
      return 'VISA';
    }
    if (amex.test(cc)) {
      setCardMask('9999 999999 99999')
      return 'AMEX';
    }
    if (mastercard.test(cc) || mastercard2.test(cc)) {
      setCardMask('9999 9999 9999 9999')
      return 'MASTERCARD';
    }
    if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
      setCardMask('9999 9999 9999 9999')
      return 'DISCOVER';
    }
    if (diners.test(cc)) {
      setCardMask('9999 9999 9999 9999')
      return 'DINERS';
    }
    if (jcb.test(cc)) {
      setCardMask('9999 9999 9999 9999')
      return 'JCB';
    }
    if (cup1.test(cc) || cup2.test(cc)) {
      setCardMask('9999 9999 9999 9999')
      return 'CHINA_UNION_PAY';
    }
    return undefined;
  }

  const changeCardNumber = (value) => {
    const valueClean = value.replace(/\s/g,'');
    setCardType(creditCardType(valueClean));
    dispatch(paymentActions.setPaymentCardNumberSpaced(value));
    dispatch(paymentActions.setPaymentCardNumber(valueClean));
    dispatch(paymentActions.setPaymentCardNumberError(''));
  }

  const changeMonth = (value) => {
    dispatch(paymentActions.setPaymentMonth(value));
    dispatch(paymentActions.setPaymentMonthError(''));
  }

  const changeYear = (value) => {
    dispatch(paymentActions.setPaymentYear(value));
    dispatch(paymentActions.setPaymentMonth(''));
    dispatch(paymentActions.setPaymentYearError(''));
  }

  const changeCvv = (value) => {
    if (value === '' || value.match(reg_ex) && value.length < 5){
      dispatch(paymentActions.setPaymentCvv(value));
    }
    dispatch(paymentActions.setPaymentCvvError(''));
  }

  const changeFirstName = (value) => {
    const currentValue = value.startsWith(' ') ? value.trim() : value;
    dispatch(paymentActions.setPaymentFirstName(currentValue));
    dispatch(paymentActions.setPaymentFirstNameError(''));
  }

  const changeAddress = (value) => {
    const currentValue = value.startsWith(' ') ? value.trim() : value;
    dispatch(paymentActions.setPaymentAddress(currentValue));
    dispatch(paymentActions.setPaymentAddressError(''));
  }

  const changeCity = (value) => {
    const currentValue = value.startsWith(' ') ? value.trim() : value;
    dispatch(paymentActions.setPaymentCity(currentValue));
    dispatch(paymentActions.setPaymentCityError(''));
  }

  const changeState = (value) => {
    dispatch(paymentActions.setPaymentState(value));
    dispatch(paymentActions.setPaymentStateError(''));
  }

  const changeZipCode = (value) => {
    value = value.replace('-','');
    if (value === '' || value.match(reg_ex)){
      value = value.substring(0, 9);
      if (value.length > 5) {
        value = [value.slice(0, 5), '-', value.slice(5)].join('');
      }
      dispatch(paymentActions.setPaymentZipCode(value));
      dispatch(paymentActions.setPaymentZipCodeError(''));
    }
  }

  const changeBankAccount = (value) => {
    dispatch(paymentActions.setPaymentBankAccount(value.trim()));
    dispatch(paymentActions.setPaymentBankAccountError(''));
  }

  const changeBankAccountName = (value) => {
    const currentValue = value.startsWith(' ') ? value.trim() : value
    dispatch(paymentActions.setPaymentBankAccountName(currentValue));
    dispatch(paymentActions.setPaymentBankAccountNameError(''));
  }

  const changeRoutingNumber = (value) => {
    if (value.length < 10) {
      dispatch(paymentActions.setPaymentRoutingNumber(value.trim()));
    }
    dispatch(paymentActions.setPaymentRoutingNumberError(''));
  }

  const addZeroRoutingNumber = () => {
    let value = paymentStore.paymentRoutingNumber;
    value = value.padStart(9, '0');
    dispatch(paymentActions.setPaymentRoutingNumber(value));
  }

  const changeAccountType = (value) => {
    dispatch(paymentActions.setPaymentAccountType(value));
    dispatch(paymentActions.setPaymentAccountTypeError(''));
  }

  const validateEmail = (value) => {
    return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
  }

  const getMessage = () => {
    let message = ''
    if (situation === 1){
      message = 'You have no balance due on your account.'
    } else if (situation === 2) {
      message = `You do not currently have a payment due.  The total remaining balance on the account is $${priceFormatted(user.balance)}.`
    } else if (situation === 3 || situation === 5) {
      message = `Your payment of <b>$${user.minimumDue}</b> was due on <b>${parseDate(user.dueDate)}.</b><br/>
                   The total remaining balance on the account is $${priceFormatted(user.balance)}.`
    } else if (situation === 4 || situation === 6){
      message = `Your payment of <b>$${user.minimumDue}</b> is due on <b>${parseDate(user.dueDate)}.</b><br/>
                   The total remaining balance on the account is $${priceFormatted(user.balance)}.`
    }
    return message;
  }

  const priceFormatted = (value) => {
    let price = value;
    price = price.toString();
    price = price.split('.');

    let priceBeforeDot = price[0];
    let priceAfterDot = price[1];

    let priceBeforeDotArray = priceBeforeDot.split('');
    let priceBeforeDotArrayReversed = priceBeforeDotArray.reverse();
    let priceBeforeDotArrayNew = [];

    for (let i = 0; i < priceBeforeDotArrayReversed.length; i++) {
      priceBeforeDotArrayNew.push(priceBeforeDotArray[i]);
      if ((i+1)%3 === 0 && i !== priceBeforeDotArrayReversed.length - 1) {
        priceBeforeDotArrayNew.push(',');
      }
    }

    priceBeforeDot = priceBeforeDotArrayNew.reverse().join('');

    if (!priceAfterDot) priceAfterDot = '00';
    if (priceAfterDot.length < 2) priceAfterDot = `${priceAfterDot}0`

    price = `${priceBeforeDot}.${priceAfterDot}`
    return price;
  }

  const parseDate = (date) => {
    const dateSplit = date.split('-');
    const year = dateSplit[0];
    const day = dateSplit[2];
    let month;
    switch (dateSplit[1]) {
      case '01' : month = 'January';
      break;
      case '02' : month = 'February';
        break;
      case '03' : month = 'March';
        break;
      case '04' : month = 'April';
        break;
      case '05' : month = 'May';
        break;
      case '06' : month = 'June';
        break;
      case '07' : month = 'July';
        break;
      case '08' : month = 'August';
        break;
      case '09' : month = 'September';
        break;
      case '10' : month = 'October';
        break;
      case '11' : month = 'November';
        break;
      case '12' : month = 'December';
        break;
      default : break;
    }

    return `${day} ${month} ${year}`
  }

  const paymentSubmit = () => {
    let paymentValid = true;
    dispatch(paymentActions.setFormError(''));
    let paymentData = {}
    if (paymentStore.paymentMethod === 'card') {
      if (cardType === 'VISA' && paymentStore.paymentCardNumber.length < 13) {
        dispatch(paymentActions.setPaymentCardNumberError('Enter correct card number'));
        paymentValid = false;
      }
      if (cardType === 'AMEX' && paymentStore.paymentCardNumber.length < 15) {
        dispatch(paymentActions.setPaymentCardNumberError('Enter correct card number'));
        paymentValid = false;
      }
      if (cardType === 'MASTERCARD' && paymentStore.paymentCardNumber.length < 16) {
        dispatch(paymentActions.setPaymentCardNumberError('Enter correct card number'));
        paymentValid = false;
      }
      if (cardType === 'DISCOVER' && paymentStore.paymentCardNumber.length < 16) {
        dispatch(paymentActions.setPaymentCardNumberError('Enter correct card number'));
        paymentValid = false;
      }

      if (!paymentStore.paymentMonth.value) {
        dispatch(paymentActions.setPaymentMonthError('Choose month'));
        paymentValid = false;
      }
      if (!paymentStore.paymentYear.value) {
        dispatch(paymentActions.setPaymentYearError('Choose year'));
        paymentValid = false;
      }
      if (paymentStore.paymentCvv.length < 3) {
        dispatch(paymentActions.setPaymentCvvError('Enter CVV'));
        paymentValid = false;
      }
      if (paymentStore.paymentFirstName.length < 3) {
        dispatch(paymentActions.setPaymentFirstNameError('Enter name as printed on your card'));
        paymentValid = false;
      }
      if (paymentStore.paymentAddress.length < 3) {
        dispatch(paymentActions.setPaymentAddressError('Enter your address'));
        paymentValid = false;
      }
      if (paymentStore.paymentCity.length < 3) {
        dispatch(paymentActions.setPaymentCityError('Enter your city'));
        paymentValid = false;
      }
      if (!paymentStore.paymentState.value) {
        dispatch(paymentActions.setPaymentStateError('Choose your state'));
        paymentValid = false;
      }
      if (paymentStore.paymentZipCode.length < 10 && paymentStore.paymentZipCode.length !== 5) {
        dispatch(paymentActions.setPaymentZipCodeError('Enter zip code (5-9 characters)'))
        paymentValid = false;
      }

      if (paymentValid) {
        paymentData['accountNumber'] = paymentStore.user.accountNumber;
        paymentData['fullName'] = paymentStore.user.fullName;
        paymentData['amount'] = paymentStore.paymentAmount;
        paymentData['cardNumber'] = paymentStore.paymentCardNumber;
        paymentData['month'] = paymentStore.paymentMonth.value;
        paymentData['year'] = paymentStore.paymentYear.value;
        paymentData['firstName'] = paymentStore.paymentFirstName.trim();
        paymentData['address'] = paymentStore.paymentAddress;
        paymentData['city'] = paymentStore.paymentCity;
        paymentData['state'] = paymentStore.paymentState.value;
        paymentData['zipCode'] = paymentStore.paymentZipCode;
        paymentData['cvv'] = paymentStore.paymentCvv;
        paymentData['sendReceipt'] = paymentStore.confirmType !== 'none';
        paymentData['sendReceiptToEmail'] = paymentStore.confirmEmail;
        if (user.pastDue) {
          paymentData['dueDate'] = user.dueDate;
        }

        dispatch(paymentActions.sendPaymentCard(paymentData))
      }

    } else {
      if (paymentStore.paymentBankAccount.length < 5) {
        dispatch(paymentActions.setPaymentBankAccountError('Enter bank account number'));
        paymentValid = false;
      }
      if (!paymentStore.paymentRoutingNumber || paymentStore.paymentRoutingNumber.length < 1) {
        dispatch(paymentActions.setPaymentRoutingNumberError('Enter routing number'));
        paymentValid = false;
      }
      if (paymentStore.paymentBankAccountName.length < 2) {
          dispatch(paymentActions.setPaymentBankAccountNameError('Enter the name on the bank account'));
          paymentValid = false;
      }
      if (paymentStore.paymentBankAccountName.length > 70) {
          dispatch(paymentActions.setPaymentBankAccountNameError('Must be less than 70 characters'));
          paymentValid = false;
      }

      let zeroCounter = 0;
      let rArr = paymentStore.paymentRoutingNumber.split('')

      rArr.forEach(number => {
        if (number === '0') {
          zeroCounter++
        }
        if (zeroCounter >= 8) {
          dispatch(paymentActions.setPaymentRoutingNumberError('Enter correct routing number'));
          paymentValid = false;
        }
      });

      if ((3 * (+rArr[0] + +rArr[3] + +rArr[6]) + 7 * (+rArr[1] + +rArr[4] + +rArr[7]) + (+rArr[2] + +rArr[5] + +rArr[8]))%10 !== 0) {
        dispatch(paymentActions.setPaymentRoutingNumberError('Enter correct routing number'));
        paymentValid = false;
      }


      if (!paymentStore.paymentAccountType.value) {
        dispatch(paymentActions.setPaymentAccountTypeError('Select account type'));
        paymentValid = false;
      }

      if (paymentValid) {
        paymentData.routingNumber = paymentStore.paymentRoutingNumber;
        paymentData.accountNumber = paymentStore.paymentBankAccount;
        paymentData.accountName = paymentStore.paymentBankAccountName;
        paymentData.accountType = paymentStore.paymentAccountType.value;
        paymentData.rvosAccountNumber = paymentStore.user.accountNumber;
        paymentData.amount = paymentStore.paymentAmount;
        paymentData.fullName = paymentStore.user.fullName;
        paymentData['sendReceipt'] = paymentStore.confirmType !== 'none';
        paymentData['sendReceiptToEmail'] = paymentStore.confirmEmail;
        if (user.pastDue) {
          paymentData['dueDate'] = user.dueDate;
        }
        dispatch(paymentActions.sendPaymentEft(paymentData))
      }
    }
  }

  const resetData = () => {
    dispatch(paymentActions.setPaymentCardNumber(''))
    dispatch(paymentActions.setPaymentYear(''))
    dispatch(paymentActions.setPaymentMonth(''))
    dispatch(paymentActions.setPaymentCvv(''))

    changeFirstName(paymentStore.paymentFirstName.trim());
    changeAddress(paymentStore.paymentAddress.trim());
    changeCity(paymentStore.paymentCity.trim());

    dispatch(paymentActions.setPaymentError(''))
    dispatch(paymentActions.setPaymentBankAccount(''))
    dispatch(paymentActions.setPaymentAccountType(''))
  }

  useEffect(() => {
    if (paymentStore.stepFirstDone &&
        paymentStore.stepSecondDone &&
        paymentStore.stepThirdDone &&
        paymentStore.stepFourthDone) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  }, [paymentStore.stepFirstDone, paymentStore.stepSecondDone, paymentStore.stepThirdDone, paymentStore.stepFourthDone]);

  useEffect(() => {
    if (user && !situation) {
      checkSituation()
    }
  });

  const SuccessPayment = () => (
    <div className="payment-steps__container">
      <div className="payment-steps__header">
        <button
            type="button"
            className="payment-steps__close-btn"
            onClick={() => dispatch(paymentActions.closePayment())}
        >
          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} />
        </button>
        <h2 className="payment-steps__title">
          Make a Payment
        </h2>
      </div>
      <div className="payment-success">
        <div className="payment-success__circle">
          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/finish.svg`} />
        </div>
        <h3 className="payment-success__title">
          Done!
        </h3>
        <div className="payment-success__text">
          <span>Your payment was successful.</span>
          <div className="payment-success__number">Confirmation number: {paymentStore.paymentConfirmationId}</div>
        </div>
        <Link
            to='/'
            className='payment-success__btn button-gradient'
            onClick={() => dispatch(paymentActions.closePayment())}
        >
          Back to the Home page
        </Link>
      </div>
    </div>
  );

  const ErrorPayment = () => (
    <div className="payment-steps__container">
      <div className="payment-steps__header">
        <button
            type="button"
            className="payment-steps__close-btn"
            onClick={() => dispatch(paymentActions.closePayment())}
        >
          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} />
        </button>
        <h2 className="payment-steps__title">
          Make a Payment
        </h2>
      </div>
      <div className="payment-failed">
        <div className="payment-failed__circle">
          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/finish.svg`} />
        </div>
        <h3 className="payment-failed__title">
          Failed!
        </h3>
        <p className="payment-failed__text">
          {paymentStore.paymentError}
        </p>
        <button
            className="payment-failed__btn button-gradient"
            onClick={() => resetData()}
        >
          Back to payment
        </button>

        {
          paymentStore.paymentErrorCount > 1 && (
            <div className="payment-issues">
              <span className="payment-issues__text">Still having issues, please </span>
                <a href="/contact-us" className="link-contact__us">contact us</a>
              <span> for assistance.</span>
            </div>
          )
        }
      </div>
    </div>
  );

  const getCurrentMonthsOptions = () => {
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();

    if (currentYear === +paymentStore.paymentYear.value) {
      return paymentStore.monthList.filter(month => parseInt(month.value) >= currentMonth);
    }

    return paymentStore.monthList;
  };

  return (
      <div className={`payment-steps ${paymentStore.isLoading ? 'is-loading' : ''}`}>
        {paymentStore.paymentResult && <SuccessPayment />}
        {paymentStore.paymentError && <ErrorPayment />}

        {
          !paymentStore.paymentResult && !paymentStore.paymentError ?
              <div className="payment-steps__container">
                <div className="payment-steps__header">
                  <button
                      type="button"
                      className="payment-steps__close-btn"
                      onClick={() => dispatch(paymentActions.closePayment())}
                  >
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} />
                  </button>
                  <h2 className="payment-steps__title">
                    Make a Payment
                  </h2>
                </div>
                <div className="payment-steps__block">
                  {user.pastDue && (
                      <span className="past-due-notification">Your account is past due.</span>
                  )}
                  <div className="steps-list">
                    <div className="steps-list__item open done">
                      <div className="steps-list__circle">
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/done.svg`} />
                      </div>
                      <div className="steps-list__item-heading">
                        Account information
                      </div>
                      <div className="steps-list__item-body">
                        <p className="steps-list__acc-number-title">
                          Account Number:
                        </p>
                        <p className="steps-list__acc-number-value">
                          Personal | {user.accountNumber}
                        </p>
                        <p className="steps-list__text" dangerouslySetInnerHTML={{__html: getMessage()}}/>
                      </div>
                    </div>
                    <div className={`steps-list__item ${paymentStore.stepFirstDone ? 'open' : ''} ${paymentStore.stepSecondDone ? 'done' : ''}`}>
                      <div className="steps-list__circle">
                        {paymentStore.stepSecondDone ? (
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/done.svg`}/>
                        ) : (
                            <span>2</span>
                        )}
                      </div>
                      <div className="steps-list__item-heading">
                        How much would you like to pay?
                      </div>
                      <div className="steps-list__item-body">
                        <div className='form-radio-group'>
                          {situation !== 1 && situation !== 2 && (
                              <label className='form-radio'>
                                <input
                                    type="radio"
                                    name="payment"
                                    value="due"
                                    className='form-radio'
                                    checked={paymentStore.paymentType === 'due'}
                                    onChange={(e) => changePaymentType(e.target.value)}
                                />
                                <div className="radio-box"/>
                                <div className="radio-text">Total amount due now: ${user.minimumDue}</div>
                              </label>
                          )}
                          {situation !== 1 && (
                              <label className='form-radio'>
                                <input
                                    type="radio"
                                    name="payment"
                                    value="total"
                                    className='form-radio'
                                    checked={paymentStore.paymentType === 'total'}
                                    onChange={(e) => changePaymentType(e.target.value)}
                                />
                                <div className="radio-box"/>
                                <div className="radio-text">Total remaining balance on account: ${priceFormatted(user.balance)}</div>
                              </label>
                          )}
                          {situation !== 1 && (
                              <label className='form-radio'>
                                <input
                                    type="radio"
                                    name="payment"
                                    value="custom"
                                    className='form-radio'
                                    checked={paymentStore.paymentType === 'custom'}
                                    onChange={(e) => changePaymentType(e.target.value)}
                                />
                                <div className="radio-box"/>
                                <div className="radio-text">Another amount</div>
                              </label>
                          )}
                        </div>
                        {paymentStore.paymentType === 'custom' && (
                            <div className="custom-input payment-amount">
                              <span className="custom-input__label">Amount</span>
                              <div className="custom-input__wrapper">
                                $
                                <input type="text"
                                       value={paymentStore.paymentCustomAmount}
                                       onChange={(e) => {changeCustomAmount(e.target.value)}}
                                       onBlur={() => {floatCustomAmount()}}
                                />
                              </div>
                            </div>
                        )}
                      </div>
                    </div>
                    <div className={`steps-list__item ${paymentStore.stepSecondDone ? 'open' : ''} ${paymentStore.stepThirdDone ? 'done' : ''}`}>
                      <div className="steps-list__circle">
                        {paymentStore.stepThirdDone ? (
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/done.svg`} />
                        ) : (
                            <span>3</span>
                        )}
                      </div>
                      <div className="steps-list__item-heading">
                        Email for payment confirmation
                      </div>
                      <div className="steps-list__item-body">
                        <div className='form-radio-group'>
                          <label className='form-radio'>
                            <input
                                type="radio"
                                name="confirm"
                                value="none"
                                className='form-radio'
                                checked={paymentStore.confirmType === 'none'}
                                onChange={(e) => changeConfirmType(e.target.value)}
                            />
                            <div className="radio-box"/>
                            <div className="radio-text">No receipt needed</div>
                          </label>
                          {user.email && (
                              <label className='form-radio'>
                                <input
                                    type="radio"
                                    name="confirm"
                                    value="user"
                                    className='form-radio'
                                    checked={paymentStore.confirmType === 'user'}
                                    onChange={(e) => changeConfirmType(e.target.value)}
                                />
                                <div className="radio-box"/>
                                <div className="radio-text">{user.email}</div>
                              </label>
                          )}
                          <label className='form-radio'>
                            <input
                                type="radio"
                                name="confirm"
                                value="custom"
                                className='form-radio'
                                checked={paymentStore.confirmType === 'custom'}
                                onChange={(e) => changeConfirmType(e.target.value)}
                            />
                            <div className="radio-box"/>
                            <div className="radio-text">
                              {user.email ? "Another email address" : "Please enter an email address"}
                            </div>
                          </label>
                        </div>
                        {paymentStore.confirmType === 'custom' && (
                            <div className="custom-input">
                              <span className="custom-input__label">Email</span>
                              <div className="custom-input__wrapper">
                                <input type="text"
                                       value={paymentStore.confirmCustomEmail}
                                       onChange={(e) => {changeCustomEmail(e.target.value)}}/>
                              </div>
                            </div>
                        )}
                      </div>
                    </div>
                    <div className={`steps-list__item ${paymentStore.stepThirdDone ? 'open' : ''} ${paymentStore.stepFourthDone ? 'done' : ''}`}>
                      <div className="steps-list__circle">
                        {paymentStore.stepFourthDone ? (
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/done.svg`} />
                        ) : (
                            <span>4</span>
                        )}
                      </div>
                      <div className="steps-list__item-heading">
                        Payment information
                      </div>
                      <div className="steps-list__item-body">
                        <div className='form-radio-group'>
                          <label className='form-radio'>
                            <input
                                type="radio"
                                name="method"
                                value="card"
                                className='form-radio'
                                checked={paymentStore.paymentMethod === 'card'}
                                onChange={(e) => changePaymentMethod(e.target.value)}
                            />
                            <div className="radio-box"/>
                            <div className="radio-text">Credit card</div>
                          </label>
                          <label className='form-radio'>
                            <input
                                type="radio"
                                name="method"
                                value="eft"
                                className='form-radio'
                                checked={paymentStore.paymentMethod === 'eft'}
                                onChange={(e) => changePaymentMethod(e.target.value)}
                            />
                            <div className="radio-box"/>
                            <div className="radio-text">Electronic Funds Transfer (bank draft)</div>
                          </label>
                        </div>
                        {paymentStore.paymentMethod === 'card' && (
                            <div className="payment-method method-card">
                              <div className="payment-method-example">
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/card-example.svg`} alt=""/>
                                {/*<img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/card-example.svg`} alt=""/>*/}
                              </div>
                              <div className="payment-method-accept">
                                <div className="payment-method-accept-title">We accept:</div>
                                <div className="payment-method-accept-list">
                                  <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/visa.png`} alt=""/>
                                  <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/mastercard.png`} alt=""/>
                                  <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/express.png`} alt=""/>
                                  <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/discover.png`} alt=""/>
                                </div>
                              </div>
                              <div className={`custom-input input-card ${paymentStore.paymentCardNumberError.length > 0 ? 'error' : ''}`}>
                                <span className="custom-input__label">Card number</span>
                                <div className="custom-input__wrapper">
                                  <InputMask mask={cardMask}
                                             maskChar={null}
                                             value={paymentStore.paymentCardNumber}
                                             onChange={(e) => {changeCardNumber(e.target.value)}}/>
                                  {paymentStore.paymentCardNumberError.length > 0 &&
                                    <div className="input-error">{paymentStore.paymentCardNumberError}</div>
                                  }
                                </div>
                              </div>
                              <div className="payment-form-row row-card-1">
                                <div className={`custom-select ${paymentStore.paymentYearError.length ? 'error' : ''}`}>
                                  <div className="custom-select__label">Year</div>
                                  <Select
                                      className="react-select"
                                      value={paymentStore.paymentYear}
                                      onChange={changeYear}
                                      options={generateYears()}
                                      placeholder='Select year'
                                      styles={customStyles}
                                  />
                                  <div className="custom-select-arrow"/>
                                  {paymentStore.paymentYearError.length > 0 &&
                                  <div className="input-error">{paymentStore.paymentYearError}</div>
                                  }
                                </div>
                                <div className={`custom-select ${paymentStore.paymentMonthError.length ? 'error' : ''}`}>
                                  <div className="custom-select__label">Month</div>
                                  <Select
                                      className="react-select"
                                      value={paymentStore.paymentMonth}
                                      onChange={changeMonth}
                                      options={getCurrentMonthsOptions()}
                                      placeholder='Select month'
                                      styles={customStyles}
                                  />
                                  <div className="custom-select-arrow"/>
                                  {paymentStore.paymentMonthError.length > 0 &&
                                  <div className="input-error">{paymentStore.paymentMonthError}</div>
                                  }
                                </div>
                                <div className={`custom-input input-cvv ${paymentStore.paymentCvvError.length > 0 ? 'error' : ''}`}>
                                  <span className="custom-input__label">CVV number</span>
                                  <div className="custom-input__wrapper">
                                    <input type="text"
                                           value={paymentStore.paymentCvv}
                                           onChange={(e) => {changeCvv(e.target.value)}}/>
                                    {paymentStore.paymentCvvError.length > 0 &&
                                      <div className="input-error">{paymentStore.paymentCvvError}</div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div className="payment-method-title">Payer info:</div>
                              <div className={`custom-input input-first-name ${paymentStore.paymentFirstNameError.length > 0 ? 'error' : ''}`}>
                                <div className="custom-input__wrapper">
                                  <input type="text"
                                          value={paymentStore.paymentFirstName}
                                          placeholder="Name as printed on card"
                                          pattern="[A-Za-z\s'-.,]+"
                                          maxLength="140"
                                          onChange={(e) => {changeFirstName(e.target.value)}}/>
                                  {paymentStore.paymentFirstNameError.length > 0 &&
                                  <div className="input-error">{paymentStore.paymentFirstNameError}</div>
                                  }
                                </div>
                              </div>
                              <div className={`custom-input input-address ${paymentStore.paymentAddressError.length > 0 ? 'error' : ''}`}>
                                <div className="custom-input__wrapper">
                                  <input type="text"
                                         value={paymentStore.paymentAddress}
                                         placeholder="Address"
                                         onChange={(e) => {changeAddress(e.target.value)}}/>
                                  {paymentStore.paymentAddressError.length > 0 &&
                                  <div className="input-error">{paymentStore.paymentAddressError}</div>
                                  }
                                </div>
                              </div>
                              <div className="payment-form-row row-card-3">
                                <div className={`custom-input input-city ${paymentStore.paymentCityError.length > 0 ? 'error' : ''}`}>
                                  <div className="custom-input__wrapper">
                                    <input type="text"
                                           value={paymentStore.paymentCity}
                                           placeholder="City"
                                           onChange={(e) => {changeCity(e.target.value)}}/>
                                    {paymentStore.paymentCityError.length > 0 &&
                                    <div className="input-error">{paymentStore.paymentCityError}</div>
                                    }
                                  </div>
                                </div>
                                <div className={`custom-select ${paymentStore.paymentStateError.length > 0 ? 'error' : ''}`}>
                                  <Select
                                      maxMenuHeight={150}
                                      className="react-select"
                                      value={paymentStore.paymentState}
                                      onChange={changeState}
                                      options={paymentStore.statesList}
                                      placeholder='State'
                                      styles={customStyles}
                                  />
                                  <div className="custom-select-arrow"/>
                                  {paymentStore.paymentStateError.length > 0 &&
                                  <div className="input-error">{paymentStore.paymentStateError}</div>
                                  }
                                </div>
                                <div className={`custom-input input-zip-code ${paymentStore.paymentZipCodeError.length > 0 ? 'error' : ''}`}>
                                  <div className="custom-input__wrapper">
                                    <input type="text"
                                           value={paymentStore.paymentZipCode}
                                           placeholder='Zip code'
                                           onChange={(e) => {changeZipCode(e.target.value)}}/>
                                    {paymentStore.paymentZipCodeError.length > 0 &&
                                    <div className="input-error">{paymentStore.paymentZipCodeError}</div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                        )}
                        {paymentStore.paymentMethod === 'eft' && (
                            <div className="payment-method method-eft">
                              <div className="payment-method-description">
                                Electronic Funds Transfer (ETF) will debit your bank account electronically without the need for a paper check.
                                The routing and account number can be found on your paper checks.
                              </div>
                                <div className="payment-form-row row-eft">
                                    <div className={`custom-input input-bank-account ${paymentStore.paymentBankAccountError.length > 0 ? 'error' : ''}`}>
                                        <span className="custom-input__label">Bank account number</span>
                                        <div className="custom-input__wrapper">
                                            <input type="text"
                                                   value={paymentStore.paymentBankAccount}
                                                   placeholder="Bank account number"
                                                   onChange={(e) => {
                                                       changeBankAccount(e.target.value)
                                                   }}/>
                                            {paymentStore.paymentBankAccountError.length > 0 &&
                                                <div
                                                    className="input-error">{paymentStore.paymentBankAccountError}</div>
                                            }
                                            <div className={`info-container ${tipBankAccountOpen ? 'open' : ''}`}>
                                            <span className="info-container__icon" onTouchStart={() => {
                                                openBankAccountTooltip()
                                            }}>
                                              <img
                                                  src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/info.svg`}/>
                                            </span>
                                                <div className="popup eft">
                                                    <div className="popup__square"/>
                                                    <h3 className="popup__title">
                                                        The account number (usually 10 digits) is the second set of
                                                        numbers printed on
                                                        the bottom
                                                    </h3>
                                                    <div className="popup__img">
                                                        <img className="form-tooltip__icon"
                                                             src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/bank-account-example.svg`}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`custom-input input-account-name ${paymentStore.paymentBankAccountNameError.length > 0 ? 'error' : ''}`}>
                                        <span className="custom-input__label">Name on the account</span>
                                        <div className="custom-input__wrapper">
                                            <input type="text"
                                                   value={paymentStore.paymentBankAccountName}
                                                   placeholder="Name on Bank Account"
                                                   onChange={(e) => {
                                                       changeBankAccountName(e.target.value)
                                                   }}/>
                                        </div>
                                        {paymentStore.paymentBankAccountNameError.length > 0 &&
                                            <div
                                                className="input-error">{paymentStore.paymentBankAccountNameError}</div>
                                        }
                                    </div>
                                </div>
                                <div className="payment-form-row row-eft">
                                    <div
                                        className={`custom-input input-routing-number ${paymentStore.paymentRoutingNumberError.length > 0 ? 'error' : ''}`}>
                                        <span className="custom-input__label">Routing Number</span>
                                        <div className="custom-input__wrapper">
                                            <input type="text"
                                                   value={paymentStore.paymentRoutingNumber}
                                                   placeholder="Routing Number"
                                                   onChange={(e) => {
                                                       changeRoutingNumber(e.target.value)
                                                   }}
                                                   onBlur={() => {
                                                       addZeroRoutingNumber()
                                                   }}/>
                                            {paymentStore.paymentRoutingNumberError.length > 0 &&
                                                <div className="input-error">{paymentStore.paymentRoutingNumberError}</div>
                                    }
                                    <div className={`info-container ${tipOpen ? 'open' : ''}`}>
                                        <span className="info-container__icon" onTouchStart={() => {openTooltip()}}>
                                          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/info.svg`}/>
                                        </span>
                                      <div className="popup eft">
                                        <div className="popup__square"/>
                                        <h3 className="popup__title">
                                          Enter the 9 digits from the first field of your bank draft
                                        </h3>
                                        <div className="popup__img">
                                          <img className="form-tooltip__icon" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/payment/uft-example.svg`}/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className={`custom-select ${paymentStore.paymentAccountTypeError.length > 0 ? 'error' : ''}`}>
                                  <div className="custom-select__label">Account Type</div>
                                  <Select
                                      className="react-select"
                                      value={paymentStore.paymentAccountType}
                                      onChange={changeAccountType}
                                      options={paymentStore.accountTypesList}
                                      placeholder='Select account type'
                                      styles={customStyles}
                                  />
                                  <div className="custom-select-arrow"/>
                                  {paymentStore.paymentAccountTypeError.length > 0 &&
                                  <div className="input-error">{paymentStore.paymentAccountTypeError}</div>
                                  }
                                </div>
                              </div>
                            </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="payment-steps__btn-container">
                    <button
                        type="button"
                        className={`payment-steps__btn button-gradient ${formValid ? '' : 'disabled'}`}
                        onClick={() => paymentSubmit()}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
              : null
        }
      </div>
  )
};

export default PaymentSteps;
